{
  "Accessibility Menu": "Меню специальных возможностей",
  "Reset settings": "Сброс настроек",
  "Close": "Закрыть",
  "Content Adjustments": "Корректировка контента",
  "Adjust Font Size": "Настройка размера шрифта",
  "Highlight Title": "Выделить заголовки",
  "Highlight Links": "Выделить ссылки",
  "Readable Font": "Читаемый шрифт",
  "Color Adjustments": "Коррекция цвета",
  "Dark Contrast": "Темный контраст",
  "Light Contrast": "Светлый контраст",
  "High Contrast": "Высокий контраст",
  "High Saturation": "Высокая насыщенность",
  "Low Saturation": "Низкая насыщенность",
  "Monochrome": "Монохромный цвет",
  "Tools": "Инструменты",
  "Reading Guide": "Руководство по чтению",
  "Stop Animations": "Остановить анимацию",
  "Big Cursor": "Большой курсор",
  "Increase Font Size": "Увеличить размер шрифта",
  "Decrease Font Size": "Уменьшить размер шрифта",
  "Letter Spacing": "Межбуквенное расстояние",
  "Line Height": "Высота линии",
  "Font Weight": "Вес шрифта",
  "Dyslexia Font": "Шрифт Дислексия",
  "Language": "Язык",
  "Open Accessibility Menu": "Открыть меню специальных возможностей"
}
